const BroadcastTimeSCP = [
    { text: "1 s", time: 1 }, 
    { text: "5 s", time: 5 },
    { text: "10 s", time: 10 },
    { text: "15 s", time: 15 },
    { text: "20 s", time: 20 },
    { text: "25 s", time: 25 },
    { text: "30 s", time: 30 },
    { text: "45 s", time: 45 },
    { text: "1 m", time: 60 },
    { text: "2 m", time: 120 },
    { text: "4 m", time: 240 },
    { text: "5 m", time: 300 },
];

export default BroadcastTimeSCP;